import React, { Suspense, lazy } from "react";
import { useDataLayer } from "@ipru-common/context/DataLayerContext";
import { DATALAYER_EVENTS } from "@ipru-common/constants/dataLayer";
import { PAGE_SECTIONS, PAGE_STEPS } from "@ipru-common/constants/products";
import { downloadFileFromUrl } from "../../../utils/CommonFunctions";
import HeaderActionButton from "../Header/HeaderActionButton";
import { COMMON_ASSETS_PATH } from "@ipru-common/constants/SiteConstants";

const RemoteAppointmentScheduling = lazy(() => import("ipru_remote/AppointmentSchedulingWithIcon"));

const HeaderRightSide = (props) => {
  const pushDataLayerEvent = useDataLayer();

  const brochureSection =
    props.currentPageStep === PAGE_STEPS.quoteScreen ? PAGE_SECTIONS.brochureQuote : PAGE_SECTIONS.brochureLanding;
  const { brochureIcon = `${COMMON_ASSETS_PATH}/header/download_arrow.svg` } = props;
  return (
    <div className="flex justify-between items-center md:gap-3 xs:gap-2">
      {/* Future HeaderActionButton can be added here */}
      {props?.buttonIconsArray?.length > 0 &&
        props.buttonIconsArray.map((item, index) => <HeaderActionButton key={index} {...item} />)}

      {props?.brochureFile && (
        <HeaderActionButton
          onClick={() => {
            if (props?.onClickBrochureDownload) {
              props.onClickBrochureDownload();
              return;
            }
            downloadFileFromUrl(props?.brochureFile);

            pushDataLayerEvent({
              event: DATALAYER_EVENTS.DownloadBrochure,
              currentSection: brochureSection,
            });
          }}
          iconSrc={brochureIcon}
          imageClassName={props?.brochureIconClassName}
          iconAlt="productguide"
          buttonClassName={props?.brochureButtonClassName}
          label={props?.brochureText}
          labelClassName={props?.brochureTextClassName}
        />
      )}
      <Suspense fallback={<div />}>
        <div className="self-baseline">
          <RemoteAppointmentScheduling
          nriHelpDeskTitle={props?.nriHelpDeskTitle}
          nriText={props?.nritext}
          talkToExpertText={props?.talkToExpertText}
          popup={true}
          handleToggle={props.handleToggle}
          talkToExpertsImage={props?.talkToExpertsImage}
          onNeedHelpClick={props?.onNeedHelpClick}
          shouldBlink={props?.shouldBlink}
          initialExpertCallNudgeVisible={props?.initialExpertCallNudgeVisible}
          talkToExpertClassName={props?.talkToExpertClassName}
          openModalRef={props?.openModalRef}
          dialogWrapperClass="text-[16px]"
         />
        </div>
      </Suspense>
    </div>
  );
};

export default HeaderRightSide;
